import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectMe, selectLinktrees, selectLinktreesCount, selectLinktreesOrderBy, selectLinktreesFilter, selectLinktreesPagination, selectLocations } from '../redux/selectors';
import { useTranslation } from 'react-i18next';
import { setSmartMenu, fetchMe, updateSmartMenu, setLinktreesPagination, fetchLinktrees, setLinktreesFilter, setLinktreesOrderBy } from '../redux/actions';
import { useNavigate } from 'react-router-dom';
import { LinktreeListView, SearchBar } from '../components';
import { useModal } from '../hooks/useModal';
import NewLinktree from '../components/modal/newLinktree';

const Linktrees = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate()

  const me = useSelector(selectMe);
  const linktreeList = useSelector(selectLinktrees);
  const count = useSelector(selectLinktreesCount);
  const orderBy = useSelector(selectLinktreesOrderBy);
  const filter = useSelector(selectLinktreesFilter);
  const pagination = useSelector(selectLinktreesPagination);
  const locations = useSelector(selectLocations);

  const itemsPerPage = 15

  const { show: showA, hide: hideA, RenderModal: RenderModalA } = useModal();
  
  useEffect(() => {
    handleOnSetPagination(null, {activePage: pagination.activePage || 0})
    dispatch(fetchMe())
    dispatch(setSmartMenu({
      buttons: [
        { key: 'add_linktree', name: 'button-add_linktree', icon: 'add', onButtonClick: ()=>showA(true)}
      ],
      navigation: null
    }))
  },[props])

  useEffect(()=>{
    if(me)
      dispatch(updateSmartMenu({
        headline: t('headline-welcome', {givenname: me.givenname})
      }))
  }, [me])
  
  useEffect(()=>{
    dispatch(setLinktreesPagination({
      ...pagination,
      totalPages: Math.ceil(count / itemsPerPage)
    }))
  }, [count])
  
  useEffect(()=>{
    let multi = itemsPerPage * (pagination.activePage -1)
    if(pagination.activePage === 1)
      multi = 0
    dispatch(fetchLinktrees(filter, itemsPerPage, multi, orderBy))
  }, [orderBy])
  
  const handleOnClickEdit = async (target) => {
    const { id, title } = target
    navigate(`/linktrees/${id}`)
  }

  const handleOnFilter = async(values) => {
    dispatch(setLinktreesFilter(values))
    dispatch(fetchLinktrees(values, itemsPerPage, 0, orderBy))
  }
  
  const handleOnChangeOrderBy = (e, { value }) => {
    dispatch(setLinktreesOrderBy(value))
  }

  const handleOnSetPagination = (e, { activePage }) => {
    let multi = itemsPerPage * (activePage -1)
    if(activePage === 1)
      multi = 0
    dispatch(fetchLinktrees(filter, itemsPerPage, multi, orderBy))
    dispatch(setLinktreesPagination({
      ...pagination,
      activePage: activePage
    }))
  }

  return (
    <article>
      <SearchBar
        show={true}
        currentFilter={filter}
        filterKey={'title'}
        onSearch={handleOnFilter}
        user={me}
      />
      <LinktreeListView
        show={true}
        pagination={pagination}
        onClickEdit={handleOnClickEdit}
        onChangeOrderBy={handleOnChangeOrderBy}
        onSetPagination={handleOnSetPagination}
        list={linktreeList}
        orderBy={orderBy}
      />
      <RenderModalA>
        <NewLinktree
          hide={hideA}
          locations={locations}
        />
      </RenderModalA>
    </article>
  );
}

export default Linktrees;